"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.TransactionStatus = exports.Currency = exports.TransactionType = exports.PaymentMethodAction = exports.PaymentMethodStatus = exports.BankAccountType = exports.CardType = exports.Vendor = void 0;
var Vendor;
(function (Vendor) {
    Vendor["ISERIES"] = "ISERIES";
    Vendor["TOKENEX_VANTIV"] = "TOKENEX_VANTIV";
    Vendor["TEST"] = "TEST";
})(Vendor = exports.Vendor || (exports.Vendor = {}));
var CardType;
(function (CardType) {
    CardType["AMEX"] = "AMEX";
    CardType["DISCOVER"] = "DISCOVER";
    CardType["MASTERCARD"] = "MASTERCARD";
    CardType["VISA"] = "VISA";
    CardType["UNKNOWN"] = "UNKNOWN";
})(CardType = exports.CardType || (exports.CardType = {}));
var BankAccountType;
(function (BankAccountType) {
    BankAccountType["CHECKING"] = "CHECKING";
    BankAccountType["SAVINGS"] = "SAVINGS";
})(BankAccountType = exports.BankAccountType || (exports.BankAccountType = {}));
var PaymentMethodStatus;
(function (PaymentMethodStatus) {
    PaymentMethodStatus["INACTIVE"] = "INACTIVE";
    PaymentMethodStatus["ACTIVE"] = "ACTIVE";
})(PaymentMethodStatus = exports.PaymentMethodStatus || (exports.PaymentMethodStatus = {}));
var PaymentMethodAction;
(function (PaymentMethodAction) {
    PaymentMethodAction["CREATE"] = "CREATE";
    PaymentMethodAction["UPDATE"] = "UPDATE";
    PaymentMethodAction["DELETED"] = "DELETED";
})(PaymentMethodAction = exports.PaymentMethodAction || (exports.PaymentMethodAction = {}));
var TransactionType;
(function (TransactionType) {
    TransactionType["AUTHORIZE"] = "AUTHORIZE";
    TransactionType["CHARGE"] = "CHARGE";
    TransactionType["SALE"] = "SALE";
    TransactionType["VERIFY"] = "VERIFY";
    TransactionType["REFUND"] = "REFUND";
})(TransactionType = exports.TransactionType || (exports.TransactionType = {}));
var Currency;
(function (Currency) {
    Currency["USD"] = "USD";
    Currency["CAD"] = "CAD";
})(Currency = exports.Currency || (exports.Currency = {}));
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["APPROVED"] = "APPROVED";
    TransactionStatus["DECLINED"] = "DECLINED";
    TransactionStatus["TIMEDOUT"] = "TIMEDOUT";
    TransactionStatus["CREATED"] = "CREATED";
    TransactionStatus["HARD_DECLINED"] = "HARD_DECLINED";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://payment-methods.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Payment Methods
 * @version v1
 * @baseUrl https://payment-methods.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags Cooldown
             * @name CooldownGetStatus
             * @request GET:/v1/identities/{identityId}/checkCooldown
             * @secure
             */
            cooldownGetStatus: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/checkCooldown`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsGetPaymentMethods
             * @request GET:/v1/identities/{identityId}/paymentMethods
             * @secure
             */
            paymentMethodsGetPaymentMethods: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsCreatePaymentMethod
             * @request POST:/v1/identities/{identityId}/paymentMethods
             * @secure
             */
            paymentMethodsCreatePaymentMethod: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsGetPaymentMethod
             * @request GET:/v1/identities/{identityId}/paymentMethods/{paymentMethodId}
             * @secure
             */
            paymentMethodsGetPaymentMethod: (identityId, paymentMethodId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${paymentMethodId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * @description Requires machine, internal, or user match JWTs
             *
             * @tags PaymentMethods
             * @name PaymentMethodsDeletePaymentMethod
             * @summary Machine, Internal, or UserMatch JWT Only
             * @request DELETE:/v1/identities/{identityId}/paymentMethods/{paymentMethodId}
             * @secure
             */
            paymentMethodsDeletePaymentMethod: (identityId, paymentMethodId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${paymentMethodId}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsGetPaymentMethodById
             * @request GET:/v1/paymentMethods/{paymentMethodId}
             * @secure
             */
            paymentMethodsGetPaymentMethodById: (paymentMethodId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/paymentMethods/${paymentMethodId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsUpdateCardPaymentDetails
             * @request POST:/v1/identities/{identityId}/paymentMethods/{paymentMethodId}/updateCardPaymentDetails
             * @secure
             */
            paymentMethodsUpdateCardPaymentDetails: (identityId, paymentMethodId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${paymentMethodId}/updateCardPaymentDetails`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsUpdateBankAccountDetails
             * @request POST:/v1/identities/{identityId}/paymentMethods/{paymentMethodId}/updateBankAccountDetails
             * @secure
             */
            paymentMethodsUpdateBankAccountDetails: (identityId, paymentMethodId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${paymentMethodId}/updateBankAccountDetails`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethods
             * @name PaymentMethodsCreateNonOwnerPaymentMethod
             * @request POST:/v1/groups/{groupId}/identities/{identityId}/paymentMethods
             * @secure
             */
            paymentMethodsCreateNonOwnerPaymentMethod: (identityId, groupId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/groups/${groupId}/identities/${identityId}/paymentMethods`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags PaymentMethodsJournal
             * @name PaymentMethodsJournal
             * @summary Machine JWT Only
             * @request GET:/v1/paymentMethods/journal
             * @secure
             */
            paymentMethodsJournal: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/paymentMethods/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PaymentMethodsJournal
             * @name PaymentMethodsJournalGetJournalMaxClock
             * @request GET:/v1/paymentMethods/journal/maxClock
             * @secure
             */
            paymentMethodsJournalGetJournalMaxClock: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/paymentMethods/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateCharge
             * @request POST:/v1/identities/{identityId}/paymentMethods/{id}/createCharge
             * @deprecated
             * @secure
             */
            transactionsCreateCharge: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${id}/createCharge`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateAuthorization
             * @request POST:/v1/identities/{identityId}/paymentMethods/{id}/createAuthorization
             * @secure
             */
            transactionsCreateAuthorization: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${id}/createAuthorization`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateSale
             * @request POST:/v1/identities/{identityId}/paymentMethods/{id}/createSale
             * @secure
             */
            transactionsCreateSale: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${id}/createSale`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateVerification
             * @request POST:/v1/identities/{identityId}/paymentMethods/{id}/createVerification
             * @secure
             */
            transactionsCreateVerification: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${id}/createVerification`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateRefund
             * @request POST:/v1/identities/{identityId}/paymentMethods/{id}/createRefund
             * @secure
             */
            transactionsCreateRefund: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/paymentMethods/${id}/createRefund`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
        this.v2 = {
            /**
             * No description
             *
             * @tags Transactions
             * @name TransactionsCreateChargeV2
             * @request POST:/v2/identities/{identityId}/paymentMethods/{id}/createCharge
             * @secure
             */
            transactionsCreateChargeV2: (identityId, id, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v2/identities/${identityId}/paymentMethods/${id}/createCharge`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=payment-methods.js.map